import { NgModule } from '@angular/core';
import { TimeService } from './time.service';
import { TimeBackend } from './time.backend';

@NgModule({
  providers: [TimeService, TimeBackend],
})
export class TimeModule {}
